module.exports = __webpack_public_path__ + "static/media/about_abtest_en.5c0c6fe7.png";